const Development = false;
export const AppEnv = {
// <=<●>=><=<●>=><=<●>=> Urls <=<●>=><=<●>=><=<●>=>
    api: Development ? 'http://127.0.0.1:8080/api/' : 'https://gestion.kolegia.com/api/',
    url: Development ? 'http://127.0.0.1:8080' : 'https://gestion.kolegia.com',
    mainColor: '#50B8B0'
};
